var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{attrs:{"name":"fade-transform","mode":"out-in"}},_vm._l((_vm.iframeViews),function(item,index){return _c('inner-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path === item.path),expression:"$route.path === item.path"}],key:item.path,attrs:{"iframeId":'iframe' + index,"src":item.meta.link}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }